import RichTextWithBlokRenderer from "../../../components/richTextRenderer/richTextRenderer";
import StoryblokImageBasic from "../../../components/storyblokImageBasic/storyblokImageBasic";
import SBEditable from "../../../components/sbEditable/sbEditable";

import styles from "./categoryheaderpanel.module.scss";
import StoryblokLink from "../../../components/link/StoryblokLink";
import { useCompressedImage } from "../../../components/storyblokImageBasic/helpers";

const CategoryHeaderPanel = ({ blok }) => {
  return (
    <SBEditable blok={blok}>
      <div
        className={styles.categoryheader}
        style={{ backgroundImage: `url(${useCompressedImage(blok.backgroundimage.filename)})` }}
      >
        <div className={styles.headercontent}>
          <h1 className={styles.header}>{blok.headline}</h1>
          <RichTextWithBlokRenderer document={blok.content} />
          {blok.ctatext ? (
            <StoryblokLink
              linkObject={blok.ctalink}
              className={`btn btn-white ${styles.headerbtn}`}
            >
              {blok.ctatext}
            </StoryblokLink>
          ) : null}
        </div>
        <div className={styles.headerimage}>
          {blok.headerimage &&
          blok.headerimage.filename !== null &&
          (!blok.mobileimage || blok.mobileimage.filename === null) ? (
            <StoryblokImageBasic
              image={blok.headerimage}
              className={styles.imageoverflow}
            />
          ) : (
            <picture>
              <source
                media="(min-width:768px)"
                srcSet={useCompressedImage(blok.headerimage.filename)}
              ></source>
              <img
                src={useCompressedImage(blok.mobileimage.filename)}
              />
            </picture>
          )}
        </div>
      </div>
    </SBEditable>
  );
};

export default CategoryHeaderPanel;
